import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from 'react-hot-toast';
const { useGeneralContext } = require("../../contexts/GeneralContext");

const Login = () => {
        const [email, setEmail] = useState("");
        const [teacher_code, setTeacherCode] = useState("");
        const [error, setError] = useState("");
        const navigate = useNavigate();
        const location = useLocation();
        const showRegisterSuccess = location.state?.showRegisterSuccess;

        const generals = useGeneralContext();

        const login = async (email, teacher_code) => {
                try {
                        const res = await axios.post("/api/teachers/login", {
                                email,
                                teacher_code
                        }, {
                                headers: {
                                        'Content-Type': 'application/json'
                                },
                                withCredentials: true
                        },);

                        navigate("/students/registrations");
                } catch (err) {
                        if (err.response?.status === 429) {
                                setError(
                                        err.response.data?.error ||
                                        "Too many login attempts. Please try again later."
                                );
                        } else {
                                setError("Invalid email or teacher code.");
                        }
                }
        };

        const handleLogin = () => {
                if (!email || !teacher_code) {
                        setError("Please complete all fields.");
                } else {
                        setError("");
                        login(email, teacher_code);
                }
        };

        useEffect(() => {
                if (showRegisterSuccess) {
                        toast.success(
                                <span>
                                        <b>Account created successfully</b><br />
                                        Please sign in with the code sent to your email.
                                </span>,
                                {
                                        duration: 5000,
                                        style: { maxWidth: '500px' },
                                }
                        )
                }
        }, [])

        return (
                <div className="auth-content">
                        <Toaster position="top-center" />

                        <div className="auth-content-title">Sign in to your account</div>
                        <div className="login-notice">
                                <b>ⓘ Accounts reset for 2026/27</b>

                                <p>
                                        All teacher accounts were reset on Friday 25 September 2026.
                                        If you registered for the 2026/27 competition before
                                        this date, please create a new account.
                                </p>
                        </div>
                        {/* <div className="auth-content-subtitle">
                                Please create a new account for {generals.YEAR}. You should have received a teacher code after creating an account.
                        </div> */}
                        {error && <div className="error-message">{error}</div>}
                        <div className="auth-form">
                                <div className="label">Your Email</div>
                                <input className="input" placeholder="jane@school.com" onChange={(e) => { setEmail(e.target.value) }} />
                                <div className="label">Teacher Code</div>
                                <input className="input" placeholder="ABCD-DCBA" onChange={(e) => { setTeacherCode(e.target.value) }} />
                                <div className="form-button" onClick={handleLogin}>
                                        <span>
                                                Sign in
                                        </span>
                                </div>
                                <div className="auth-alt-text">
                                        Don't have an account? <Link to="/register" className="auth-link">Sign up as a teacher</Link>
                                </div>
                        </div>
                </div>
        );
};

export default Login;